import { PortfolioSecurityAllocation } from 'generated/types'
import { USDFormatter } from 'utils/number/currency'

export const percentFormatter = (percent: number) => {
  return percent >= 0 ? `+${percent}%` : `-${Math.abs(percent)}%`
}

export const valueFormatter = (value: number) => {
  return value >= 0
    ? `+${USDFormatter.format(value)}`
    : `-${USDFormatter.format(Math.abs(value))}`
}

// TODO: Remove this once we can get rid of legacy portfolio
export const normalizeItems = (
  portfolioSecurityAllocations: PortfolioSecurityAllocation[],
) => {
  return portfolioSecurityAllocations.map(
    (security: PortfolioSecurityAllocation) => {
      return {
        ...security,
        percent: security.allocationPercent / 100,
      }
    },
  )
}
